import {
  Component,
  Input,
  Output,
  OnInit,
  Attribute,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core'
import { startCase, toLower } from 'lodash';

@Component({
  selector: 'sortable',
  templateUrl: './sortable.component.html',
  styleUrls: ['./sortable.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SortableComponent implements OnInit {
  @Input() keys: any[]
  @Input() sortBy: string
  @Input() reverse: boolean
  @Input() useDropdown: boolean = false
  @Output() sortByChange: EventEmitter<string> = new EventEmitter<string>()
  @Output() reverseChange: EventEmitter<boolean> = new EventEmitter<boolean>()

  dropValue: any

  ngOnInit() {
    this.dropValue = this.sortBy
    this.keys = this.keys.map(key => {
      if (typeof key === 'string') {
        return {
          name: startCase(toLower(key)),
          id: key
        }
      } else {
        return key
      }
    })
  }

  sort(id) {
    if (this.sortBy !== id) {
      this.reverse = false
    } else {
      this.reverse = !this.reverse
    }
    this.sortBy = id
    this.reverseChange.emit(this.reverse)
    this.sortByChange.emit(this.sortBy)
  }
}
